@if (item) {
	<app-accordeon
		[view]="'classic'"
		[isOpenable]="item.status === 'SIGNED' || this.item.status === 'WAITING'"
	>
		<div
			class="statement-block__header-block"
			title
		>
			<span class="statement__head-field statement__head-field--image">
				@if (item.status !== 'WAITING') {
					<app-svg-document-one-list
						width="30px"
						heigth="30px"
					></app-svg-document-one-list>
				} @else {
					<app-svg-exclamation-mark
						class="statement__exclamation-mark"
						width="30px"
						heigth="30px"
						[backgroundColor]="'#e7ad42'"
					></app-svg-exclamation-mark>
				}
			</span>
			<span
				class="statement__head-field statement__head-field--date"
				title="Дата создания"
			>
				{{ item.creationDate | date: 'dd.MM.yyyy' }}
			</span>
			<span
				class="statement__head-field statement__head-field--number"
				title="Номер заявления"
			>
				{{ item.regNumber }}
			</span>
			<section
				class="accordeon__title-text statement__head-field statement__head-field--title"
			>
				<h2
					class="statement__head-statement-title"
					title="Название заявления: {{ title }}"
				>
					{{ title }}
				</h2>
			</section>
			<div
				class="statement__head-field statement__head-field--status"
				title="Статус"
			>
				<span
					class="color-status"
					[ngClass]="{
						'color-status--done': item.status === 'SIGNED' || item.status === 'DONE',
						'color-status--in-progress':
							item.status === 'WAITING' || item.status === 'IN_PROGRESS',
						'color-status--canceled': item.status === 'DENIED',
					}"
				>
					{{ StatementStatuses[item.status] || 'Не определено' }}
				</span>
			</div>
			<div
				class="statement__head-field statement__head-field--product"
				title="Продукт: {{ item.product.name }}"
			>
				<app-product-image
					[image]="item.product.image"
					[productImageParams]="{ size: CARD_PICTURE.MOBILE }"
				></app-product-image>
				<span class="statement__head-product-title">
					{{ item.product.name }}
				</span>
			</div>
		</div>

		<div
			class="statement-block__content-block"
			content
		>
			<app-statement-order [item]="item"></app-statement-order>
		</div>
	</app-accordeon>
}
